/**
 * A restriction adapter That lets you specify a true or false resolution for debugging.
 * You can also include an optional message that will be printed to the console when the
 * restriction resolves.
 *
 * "debug:true:This message will be printed in the console"
 * "debug:false:This message will also be printed in the console"
 */

export const NAME = '^debug:(.+?)(:(.+))?$';

export default function isAllowed(restriction) {
	let [,result,,message] = restriction.match(NAME);
	if (message) console.log(message); //eslint-disable-line no-console
	return Promise.resolve(result === 'true');
}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/adapters/debug/index.js